import {ApiErrors} from "./index";
import loginApiErrors from "../api/login/errors";
import deviceApiErrors from "../api/device/errors";

const apiErrors: ApiErrors = {
    'login': loginApiErrors,
    'device': deviceApiErrors
};

export default apiErrors;